<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-6">
            <div class="card mt-5">
                <div class="card-body">
                    <h2 class="card-title text-center mb-4">Reset Password</h2>
                    <p class="text-center mb-4">
                        Inserisci la tua email per ricevere le istruzioni per reimpostare la password.
                    </p>
                    <form [formGroup]="form">
                        <div class="mb-4">
                            <label for="email" class="form-label">Email</label>
                            <input type="email"  formControlName="email" class="form-control" id="email"  required valid="email">
                        </div>
                        <div class="d-grid">
                            <button type="submit" (click)="reset()"  class="btn btn-primary">Reset</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>